import { DimensionScore } from '@/graphql/types/dimensions';

interface SortTableProps {
  header: string;
  id?: number | string;
  variant?: 'risk' | 'opportunity';
}

const valuesToSortTable = ({ header, id, variant }: SortTableProps): string => {
  const headerNormalized = header.toLowerCase();

  switch (headerNormalized) {
    case 'municipality':
    case 'município':
      return 'name_municipality';
    case 'state':
    case 'estado':
      return 'name_uf';

    case 'classification':
    case 'classificação':
      return variant === 'risk' ? 'classification_risk' : 'classification_opportunity';

    case 'risk level':
    case 'nível de risco':
      return 'general_score_risk';

    case 'opportunity level':
    case 'nível de oportunidade':
      return 'general_score_opportunity';
    default:
      return `dimension_${id}`;
  }
};

const sortDimensions = (dimensions: DimensionScore[], customOrder: number[]): DimensionScore[] => {
  return [...dimensions].sort((a, b) => {
    const orderA = customOrder.indexOf(a.dimension.order);
    const orderB = customOrder.indexOf(b.dimension.order);
    return orderA - orderB;
  });
};

export const sort = {
  valuesToSortTable,
  sortDimensions,
};
